export const STATUS_TR = {
  PENDING: "Beklemede",
  CONFIRMED: "Onaylandı",
  PAID: "Ödendi",
  PAYING: "Ödeme Sürecinde",
  PROCESSING: "İşlemde",
  DELIVERED: "Teslim Edildi",
  COMPLETED: "Tamamlandı",
  CANCELLED: "İptal Edildi",
  DRAFT: "Taslak",
  MANUAL: "Manuel",
};

export const STATUS_COLOR = {
  PENDING: "bg-amber-50 text-amber-800 border-amber-300",
  CONFIRMED: "bg-emerald-50 text-emerald-800 border-emerald-300",
  PAID: "bg-[#1C4E35]/10 text-[#1C4E35] border-[#1C4E35]/30",
  PROCESSING: "bg-sky-50 text-sky-800 border-sky-300",
  PAYING: "bg-sky-50 text-sky-800 border-sky-300",
  DELIVERED: "bg-emerald-50 text-emerald-800 border-emerald-300",
  COMPLETED: "bg-emerald-50 text-emerald-800 border-emerald-300",
  CANCELLED: "bg-red-50 text-red-700 border-red-300",
  MANUAL: "bg-violet-50 text-violet-800 border-violet-300",
};

export const statusLabel = (s) => STATUS_TR[s] || s || "-";
export const statusClass = (s) => STATUS_COLOR[s] || "bg-stone-100 text-stone-700 border-stone-300";

export const UNIT_TR = {
  piece: "adet",
  pack: "paket",
  package: "paket",
  m2: "m²",
  m: "mtül",
  set: "set",
  day: "gün",
  hour: "saat",
};

export const unitLabel = (u) => UNIT_TR[(u || "").toLowerCase()] || u || "adet";

export const fmtMoney = (v, cur = "USD") => {
  if (!v && !cur) return "—";
  return new Intl.NumberFormat("tr-TR", { style: "currency", currency: cur || "USD", maximumFractionDigits: 0 }).format(v || 0);
};

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

const MONTH_TR = { Jan: "Oca", Feb: "Şub", Mar: "Mar", Apr: "Nis", May: "May", Jun: "Haz", Jul: "Tem", Aug: "Ağu", Sep: "Eyl", Oct: "Eki", Nov: "Kas", Dec: "Ara" };

export const detailTr = (s) => {
  if (!s) return s;
  let out = s.replace(/(\d+)\s+days?/gi, "$1 gün").replace(/full event/gi, "Tüm etkinlik");
  Object.entries(MONTH_TR).forEach(([en, tr]) => {
    out = out.replace(new RegExp(en, "gi"), tr);
  });
  return out;
};
